import React from 'react'
import { Box, TextField, Card, Button, useMediaQuery } from '@mui/material'
import { useLocale } from 'src/locales/useLocale'

type Props = {
  content: string
  contentMaxLength: number
  embroideryIndex?: number
  caution?: string
  description?: string
  disabled?: boolean
  handleContent: (selected: string, i?: number) => void
}

export const EmbroideryContentUs: React.FC<Props> = ({
  content,
  contentMaxLength,
  embroideryIndex,
  caution,
  description,
  disabled,
  handleContent
}) => {
  const { t } = useLocale()
  const handleHeartEmoji = () => {
    handleContent(content + '🩷', embroideryIndex)
  }
  const handleStarEmoji = () => {
    handleContent(content + '⭐️', embroideryIndex)
  }
  const isMobile = useMediaQuery('(max-width:430px)')
  return (
    <Card>
      <Box mr={2} fontSize={10}>
        {t.EMBROIDERY_CONTENTS}
      </Box>
      <Box display="flex" alignItems="center" mx={1} mt={2}>
        <TextField
          maxRows={1}
          onChange={(event) => {
            handleContent(event.target.value, embroideryIndex)
          }}
          variant="outlined"
          style={{ width: '75%', background: disabled ? 'gainsboro' : '#fff' }}
          defaultValue={content}
          inputProps={{ maxLength: contentMaxLength }}
          disabled={disabled}
        />
        {!isMobile && (
          <>
            <Button onClick={handleHeartEmoji} variant={'outlined'} disabled={disabled}>
              🩷
            </Button>
            <Button onClick={handleStarEmoji} variant={'outlined'} disabled={disabled}>
              ⭐️
            </Button>
          </>
        )}
      </Box>
      <Box pl={3} fontSize={'12px'}>
        {t.MAX_NUMBER_OF_CHAR}：{contentMaxLength}
        {t.CHARACTERS}
      </Box>
      {caution && (
        <Box pl={3} textAlign="left" color={'red'} fontSize={'12px'}>
          {caution}
        </Box>
      )}
      {description && (
        <Box pl={3} textAlign="left" color={'blue'} fontSize={'12px'}>
          {description}
        </Box>
      )}
    </Card>
  )
}
